
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/track/[slugMeditation]",
      function () {
        return require("private-next-pages/track/[slugMeditation]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/track/[slugMeditation]"])
      });
    }
  